import { Action} from 'redux';
import 'rxjs';
import { ActionsObservable, StateObservable } from 'redux-observable';
import { RootState } from '.';
import { of, Observable } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';
import { ajax, AjaxResponse } from 'rxjs/ajax';

export const LOAD_FIELDS = "INFO_LOAD_FIELDS";
export const LOAD_FIELDS_FULFILLED = "INFO_LOAD_FIELDS_FULFILLED";
export const LOAD_FIELDS_FAILED = "INFO_LOAD_FIELDS_FAILED";

export interface Constraint {
    regex?: RegexConstraint,
    list?: string[],
    associated?: string[],
    textarea?: boolean,
    tagged_input?: boolean
}

export interface RegexConstraint {
    expression: string,
    requires_match: boolean
}

export type FieldInfo = {
    title: string,
    type: "bbox" | "content" | "text" | "long" | "int" | "date" | "double" | "boolean" | "path",
    description?: string,
    is_mandatory: boolean,
    is_multivalued: boolean,
    constraints?: Constraint
}

export type FieldMap = {[field_name: string]: FieldInfo}

export type InfoState = {
    fields: FieldMap,
    lookup : {[field_name: string]: string},
    error: {}
};

const initialState: InfoState = {
    fields: {
        "path_starts_with": {
            title: "Path Starts With",
            type: "path",
            is_mandatory: false,
            is_multivalued: false
        },
        "type": {
            title: "Type",
            type: "text",
            is_mandatory: false,
            is_multivalued: false
        },
        "mime_type": {
            title: "Mime type",
            type: "text",
            is_mandatory: false,
            is_multivalued: false            
        },
        "size": {
            title: "File size",
            type: "long",
            is_mandatory: false,
            is_multivalued: false
        },
        "id": {
            title: "Node ID",
            type: "text",
            is_mandatory: false,
            is_multivalued: false
        }
    },
    // for provide the corresponding labels for fields name coming back from solr or Alfresco
    lookup: {"path": "Path", "path_starts_with": "Path Starts With", "type": "Type", "size": "File size", "mime_type": "Mime type", "aspects": "Aspects", "site": "Site", "id": "Node ID", "[NOW-1DAY TO NOW]": "Today", "[NOW-7DAYS TO NOW]": "This Week", "[NOW-1MONTH TO NOW]": "This Month", "[NOW-1YEAR TO NOW]": "This Year", "[* TO NOW-1YEAR]": "Older than a Year"},
    error: {}
};


export interface LoadFieldsFulfilledAction extends Action {
    type: "INFO_LOAD_FIELDS_FULFILLED",
    fields: FieldMap
}

export interface LoadFieldsFailedAction extends Action {
    type: "INFO_LOAD_FIELDS_FAILED",
}

export type InfoAction = LoadFieldsFulfilledAction | LoadFieldsFailedAction;


export const loadFields = (): Action => ({ type: LOAD_FIELDS });

export const loadFieldsEpic = (action$: ActionsObservable<Action>, state$: StateObservable<RootState>): Observable<Action> =>
action$.ofType(LOAD_FIELDS).pipe(
switchMap(action =>  {


    return ajax.get("api/v1/fields").pipe(
    map((response: AjaxResponse) => {
        return {
            type:  LOAD_FIELDS_FULFILLED,
            fields: response.response
        }

    }),
    catchError((error) => of({type: LOAD_FIELDS_FAILED})),)

}))

export default function reducer(state = initialState, action: InfoAction ): InfoState {
    switch(action.type) {
        case LOAD_FIELDS_FULFILLED: {

            if(action.fields != undefined) {
                let lookup = state.lookup;
                let fields = action.fields;

                if (fields["cm_content"]) {
                    fields["cm_content"].is_multivalued = true;
                }
    
                Object.keys(fields).forEach((key) => {
                    if(fields[key].title) {
                        lookup[key] = fields[key].title;
                    }
                });
    
                return {
                    ...state,
                    fields: {
                        ...state.fields,
                        ...fields
                    },
                    lookup: lookup
                }

            }

        }
 
        default:
            return state;
    }

}